exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment[data-v-1dc61052]{height:46px;border-radius:5px}.pointer[data-v-1dc61052]{cursor:pointer}.card[data-v-1dc61052]{border-radius:0!important}.nav-link.active[data-v-1dc61052]{background-color:#fff!important}.removePadding[data-v-1dc61052]{padding:0;margin:5px 0 0}.seeAttach[data-v-1dc61052]{border:1px solid #3490dc;padding:10px 25px;color:#3490dc}", ""]);

// exports
